import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { protoColors } from '../../../../theme/tokens';

export const List = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '560px',
  overflowY: 'auto',
  gap: '6px',
  paddingRight: '4px',
}));

export const Row = styled('button', {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ selected }) => ({
  border: `1px solid ${selected ? protoColors.purple : protoColors.border}`,
  backgroundColor: selected ? protoColors.purpleSoft : protoColors.surface,
  borderRadius: '10px',
  padding: '10px 12px',
  cursor: 'pointer',
  textAlign: 'left',
  fontFamily: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  '&:hover': {
    borderColor: protoColors.purple,
  },
}));

export const Name = styled('span')(() => ({
  fontSize: '13.5px',
  fontWeight: 600,
  color: protoColors.textPrimary,
}));

export const Sub = styled('span')(() => ({
  fontSize: '12px',
  color: protoColors.textMuted,
}));

export const MetricBadge = styled('span', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  fontSize: '12.5px',
  fontWeight: 700,
  color,
  whiteSpace: 'nowrap',
}));
